/**
 * Logs an error in the console. Note: it does not generate a JavaScript error, so make sure to also
 * generate an error if needed.
 */
export function logConsoleError() {
  // eslint-disable-next-line no-console
  console.error.apply(console, /** @type {any[]} */ (/** @type {unknown} */ (arguments)));
}

/** Logs a warning in the console. */
export function logConsoleWarn() {
  // eslint-disable-next-line no-console
  console.warn.apply(console, /** @type {any[]} */ (/** @type {unknown} */ (arguments)));
}
